// SpaMassageCarousel.tsx
"use client";

import SpaMassageCard from "@/components/card/SpaMassageCard";
import HomeCarouselSection from "../../HomeCarouselSection";
import MediaCardSkeleton from "@/components/skeletons/card/MediaCardSkeleton";
import { useSpaAndMassageCarousel } from "@/hooks/spa-msg/useSpaAndMassage";
import { SpaListingCaruselItem } from "@/components/main-services/spa-msg/spa-msg.type";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useInView } from "@/hooks/useObserver";

interface SpaMassageCarouselProps {
  title: string;
  icon?: string;
  href?: string;
  type?: SpaListingCaruselItem["type"];
}

const SpaMassageCarousel = ({
  title,
  icon,
  href,
  type,
}: SpaMassageCarouselProps) => {
  const [containerRef, inView] = useInView("300px");
  const isMdUp = useMediaQuery("(min-width: 768px)");
  const {
    data: spaMsg,
    isFetching,
    isError,
  } = useSpaAndMassageCarousel(undefined, inView);

  const items = type
    ? spaMsg?.items?.filter((item: { type: string }) => item.type === type)
    : spaMsg?.items;

  if (inView && !isFetching && items?.length === 0) return null;

  return (
    <div ref={containerRef}>
      <HomeCarouselSection<SpaListingCaruselItem>
        title={title}
        icon={icon}
        href={href}
        items={items}
        isFetching={isFetching}
        isError={isError}
        itemsPerCol={isMdUp ? 4 : 3}
        getKey={(item) => item.id}
        renderItem={(item) => <SpaMassageCard data={item} />}
        renderSkeleton={() => <MediaCardSkeleton />}
      />
    </div>
  );
};

export default SpaMassageCarousel;
